import { OUTBOUND_MANIFEST_TYPES } from '@/constants/manifestStatuses';
import { inboundConfig } from './inbound';
import { outboundConfig } from './outbound';

// One grid, one config per manifest type — no branching inside the components.
export const getManifestGridConfig = (type) =>
    OUTBOUND_MANIFEST_TYPES.includes(type) ? outboundConfig : inboundConfig;
